import request from '../../../../../setup/axios/request'
import requestFile from '../../../../../setup/axios/request-file'

const lang = localStorage.getItem('i18nConfig')
const lang_r = lang ? JSON.parse(lang).selectedLang : 'VI'

export const calculateFeeHouse = (data: any) => {
  data.languageCode = lang_r.toUpperCase()
  return request({
    url: '/api/v1/Pricing/caculator-fee-house',
    method: 'post',
    data: data,
  })
}

export const addHouseInsured = (data: any) => {
  return request({
    url: '/api/v1/SellingHouse/step2-add-object-insured-house',
    method: 'post',
    data: data,
  })
}

export const getHouseInsuredById = (data: any) => {
  return request({
    url:
      '/api/v1/SellingHouse/step2-object-insured-house-detail-byid?sellingContractId=' +
      data.sellingContractId +
      '&id=' +
      data.id,
    method: 'get',
  })
}

export const getListHouseInsured = (data: any) => {
  let obj = {
    Page: data.pageNumber,
    PageSize: data.pageSize,
    Filters: data.filter,
  }
  return request({
    url: '/api/v1/SellingHouse/step2-list-object-insured-house',
    method: 'get',
    headers: {
      'x-query': JSON.stringify(obj),
    },
  })
}

export const pricingPackageInfo = (code: string) => {
  return request({
    url: '/api/v1/Pricing/cargoPackages?Code=' + code + '&languageCode=' + lang_r.toUpperCase(),
    method: 'get',
  })
}

export const step2ContractPackageCargo = (data: any) => {
  return request({
    url: '/api/v1/SellingCargo/step2-contractPackage-cargo',
    method: 'post',
    data: data,
  })
}

export const step2GetContractPackageCargo = (sellingContractId: string) => {
  let obj = {
    Page: '1',
    PageSize: '20',
    sorts: [
      {
        fieldName: 'PackageName',
        direction: 1,
      },
    ],
  }
  return request({
    url: '/api/v1/SellingCargo/step2-contractPackage-cargo?id=' + sellingContractId,
    method: 'get',
    headers: {
      'x-query': JSON.stringify(obj),
    },
  })
}

export const step2GetContractPackageCargoByCode = (data: any) => {
  return request({
    url:
      '/api/v1/SellingCargo/step2-contractPackage-cargo-by-code?code=' +
      data.code +
      '&sellingContractId=' +
      data.sellingContractId,
    method: 'get',
  })
}

export const step2DeleteContractPackageCargoByid = (data: any) => {
  return request({
    url: '/api/v1/SellingCargo/step2-delete-cargo-contractPackage-byid',
    method: 'delete',
    data: data,
  })
}

export const step2CopyPackageCargo = (data: any) => {
  return request({
    url: '/api/v1/SellingCargo/copy-cargo-package',
    method: 'post',
    data: data,
  })
}

export const calculatorFeeCargo = (data: any) => {
  data.languageCode = lang_r.toUpperCase()
  return request({
    url: '/api/v1/Pricing/caculator-fee-ecargo',
    method: 'post',
    data: data,
  })
}

export const step4GetContractPackageCargo = (sellingContractId: string) => {
  let obj = {
    Page: '1',
    PageSize: '10',
    Filters: [
      {
        FieldName: 'SellingContractId',
        Comparision: '==',
        FieldValue: sellingContractId,
      },
    ],
  }
  return request({
    url: '/api/v1/SellingCargo/step3-object-insured-cargo-list',
    method: 'get',
    headers: {
      'x-query': JSON.stringify(obj),
    },
  })
}

export const step4GetObjectInsuredById = (data: any) => {
  return request({
    url:
      '/api/v1/SellingCargo/step3-object-insured-cargo-detail-byid?sellingContractId=' +
      data.sellingContractId +
      '&id=' +
      data.id,
    method: 'get',
  })
}

export const step4ObjectInsuredCargoDetailsUpdate = (data: any) => {
  return request({
    url: '/api/v1/SellingCargo/step3-object-insured-cargo-details-update',
    method: 'post',
    data: data,
  })
}

export const calculatorFeeCargoStep4 = (data: any) => {
  return request({
    url: '/api/v1/Pricing/caculator-fee-ecargo-step3',
    method: 'post',
    data: data,
  })
}

export const searchAndPagingInspectionCompany = (data: any) => {
  let dataFilter = {
    filter: {
      searchField: data.filter,
      code: '',
      name: '',
      languageCode: lang_r.toUpperCase(),
    },
    orderBy: [
      {
        fieldName: '',
        direction: 0,
      },
    ],
    languageCode: lang_r.toUpperCase(),
    pageIndex: data.pageIndex,
    pageSize: data.pageSize,
    showTotal: true,
  }

  return request({
    url: '/api/v1/Selling/Cargo/InspectionCompany/search-and-pagging',
    method: 'post',
    data: dataFilter,
  })
}

export const pricingMarinePackageInfo = (code: string) => {
  return request({
    url: '/api/v1/Pricing/marinePackages?Code=' + code + '&languageCode=' + lang_r.toUpperCase(),
    method: 'get',
  })
}

export const step2GetContractPackageMarine = (sellingContractId: string) => {
  let obj = {
    Page: '1',
    PageSize: '20',
    sorts: [
      {
        fieldName: 'Name',
        direction: 1,
      },
    ],
  }
  return request({
    url: '/api/v1/SellingMarine/step2-contractPackage-marine?id=' + sellingContractId,
    method: 'get',
    headers: {
      'x-query': JSON.stringify(obj),
    },
  })
}

export const step2DeleteContractPackageMarineByid = (data: any) => {
  return request({
    url: '/api/v1/SellingMarine/step2-delete-marine-contractPackage-byid',
    method: 'delete',
    data: data,
  })
}

export const step2CopyPackageMarine = (data: any) => {
  return request({
    url: '/api/v1/SellingMarine/copy-marine-package',
    method: 'post',
    data: data,
  })
}

export const step2GetContractPackageMarineByCode = (data: any) => {
  return request({
    url:
      '/api/v1/SellingMarine/step2-contractPackage-marine-by-code?code=' +
      data.code +
      '&sellingContractId=' +
      data.sellingContractId,
    method: 'get',
  })
}

export const step2ContractPackageMarine = (data: any) => {
  return request({
    url: '/api/v1/SellingMarine/step2-contractPackage-marine',
    method: 'post',
    data: data,
  })
}

export const calculatorFeeMarineStep2 = (data: any) => {
  data.languageCode = lang_r.toUpperCase()
  return request({
    url: '/api/v1/Pricing/caculator-fee-marine-step2',
    method: 'post',
    data: data,
  })
}

export const step3GetObjectInsuredMarineList = (data: any) => {
  let obj = {
    Page: data.pageNumber,
    PageSize: data.pageSize,
    Filters: data.filter,
  }

  return request({
    url: '/api/v1/SellingMarine/step3-object-insured-marine-list',
    method: 'get',
    headers: {
      'x-query': JSON.stringify(obj),
    },
  })
}

export const step3GetObjectInsuredMarineByID = (data: any) => {
  return request({
    url:
      '/api/v1/SellingMarine/step3-object-insured-marine-detail-byid?sellingContractId=' +
      data.sellingContractId +
      '&id=' +
      data.id,
    method: 'get',
  })
}

export const step3CalculateFee = (data: any) => {
  return request({
    url: '/api/v1/Pricing/caculator-fee-marine-step3',
    method: 'post',
    data: data,
  })
}

export const step3ObjectInsuredMarineDetailsAdd = (data: any) => {
  return request({
    url: '/api/v1/SellingMarine/step3-add-object-insured-marine',
    method: 'post',
    data: data,
  })
}

export const searchAndPagingShipLevel = (data: any) => {
  let dataFilter = {
    filter: {
      searchField: '',
      code: '',
      name: '',
      languageCode: lang_r.toUpperCase(),
    },
    orderBy: [
      {
        fieldName: '',
        direction: 0,
      },
    ],
    ListFilter: [
      {
        PropertyName: data.propertyName,
        Operation: 6,
        Value: data.value,
        TypeSearch: 0,
      },
    ],
    languageCode: lang_r.toUpperCase(),
    pageIndex: 0,
    pageSize: -1,
    showTotal: true,
  }

  return request({
    url: '/api/v1/Selling/ShipLevel/search-and-pagging',
    method: 'post',
    data: dataFilter,
  })
}

export const step2GetObjectInsuredPropertyList = (data: any) => {
  let obj = {
    Page: data.pageNumber,
    PageSize: data.pageSize,
    Filters: data.filter,
  }

  return request({
    url: 'api/v1/SellingProperty/step2-object-insured-property-list',
    method: 'get',
    headers: {
      'x-query': JSON.stringify(obj),
    },
  })
}

export const step2ContractPackageMicro = (data: any) => {
  return request({
    url: '/api/v1/SellingMicro/step2-contractPackage-micro',
    method: 'post',
    data: data,
  })
}

export const step2GetContractPackageMicro = (sellingContractId: string) => {
  let obj = {
    Page: '1',
    PageSize: '20',
    sorts: [
      {
        fieldName: 'Name',
        direction: 1,
      },
    ],
  }
  return request({
    url: '/api/v1/SellingMicro/step2-get-list-contractPackage-micro?id=' + sellingContractId,
    method: 'get',
    headers: {
      'x-query': JSON.stringify(obj),
    },
  })
}

export const step3GetObjectInsuredMicroList = (data: any) => {
  let obj = {
    Page: data.pageNumber,
    PageSize: data.pageSize,
    Filters: data.filter,
  }

  return request({
    url: 'api/v1/SellingMicro/ste3-object-insured-micro-list',
    method: 'get',
    headers: {
      'x-query': JSON.stringify(obj),
    },
  })
}

export const step3GetObjectInsuredMicroByID = (data: any) => {
  return request({
    url:
      'api/v1/SellingMicro/step3-object-insured-micro-detail-byid?sellingContractId=' +
      data.sellingContractId +
      '&id=' +
      data.id,
    method: 'get',
  })
}

export const step3AddObjectInsuredMicro = (data: any) => {
  return request({
    url: '/api/v1/SellingMicro/step3-object-insured-micro-add',
    method: 'post',
    data: data,
  })
}

export const step2GetContractPackageMicroByCode = (data: any) => {
  return request({
    url:
      '/api/v1/SellingMicro/step2-contractPackage-micro-by-code?code=' +
      data.code +
      '&sellingContractId=' +
      data.sellingContractId,
    method: 'get',
  })
}

export const calculatorFeeMicroStep2 = (data: any) => {
  data.languageCode = lang_r.toUpperCase()
  return request({
    url: '/api/v1/Pricing/caculator-fee-micro-step2',
    method: 'post',
    data: data,
  })
}

export const step2DeleteContractPackageMicroByid = (data: any) => {
  return request({
    url: 'api/v1/SellingMicro/step2-delete-micro-contractPackage-byid',
    method: 'delete',
    data: data,
  })
}

export const step2CopyPackageMicro = (data: any) => {
  return request({
    url: '/api/v1/SellingMicro/copy-micro-package',
    method: 'post',
    data: data,
  })
}

export const searchAndPagingBusiness = (data: any) => {
  let dataFilter = {
    filter: {
      searchField: data.filter,
      code: '',
      name: '',
      languageCode: lang_r.toUpperCase(),
    },
    orderBy: [
      {
        fieldName: '',
        direction: 0,
      },
    ],
    ListFilter: [
      {
        PropertyName: 'BusinessAreaCode',
        Operation: 1,
        Value: data.businessAreaCode,
        TypeSearch: 0,
      },
    ],
    languageCode: lang_r.toUpperCase(),
    pageIndex: data.pageIndex - 1,
    pageSize: data.pageSize,
    showTotal: true,
  }

  return request({
    url: '/api/v1/Selling/PropertyBusiness/search-and-pagging',
    method: 'post',
    data: dataFilter,
  })
}
export const searchAndPagingBusinessAreas = (data: any) => {
  let dataFilter = {
    filter: {
      searchField: data.filter,
      code: '',
      name: '',
      languageCode: lang_r.toUpperCase(),
    },
    orderBy: [
      {
        fieldName: '',
        direction: 0,
      },
    ],
    languageCode: lang_r.toUpperCase(),
    pageIndex: data.pageIndex - 1,
    pageSize: data.pageSize,
    showTotal: true,
  }

  return request({
    url: '/api/v1/Selling/BusinessAreas/search-and-pagging',
    method: 'post',
    data: dataFilter,
  })
}
export const searchAndPagingPropertyRisk = (data: any) => {
  let dataFilter = {
    filter: {
      searchField: data.filter,
      code: '',
      name: '',
      languageCode: lang_r.toUpperCase(),
    },
    orderBy: [
      {
        fieldName: '',
        direction: 0,
      },
    ],
    languageCode: lang_r.toUpperCase(),
    pageIndex: data.pageIndex - 1,
    pageSize: data.pageSize,
    showTotal: true,
  }

  return request({
    url: '/api/v1/Selling/PropertyRisk/search-and-pagging',
    method: 'post',
    data: dataFilter,
  })
}
export const searchAndPagingPropertyBusinessInterruption = (data: any) => {
  let dataFilter = {
    filter: {
      searchField: data.filter,
      code: '',
      name: '',
      languageCode: lang_r.toUpperCase(),
    },
    orderBy: [
      {
        fieldName: '',
        direction: 0,
      },
    ],
    languageCode: lang_r.toUpperCase(),
    pageIndex: data.pageIndex - 1,
    pageSize: data.pageSize,
    showTotal: true,
  }

  return request({
    url: '/api/v1/Selling/BusinessInterruption/search-and-pagging',
    method: 'post',
    data: dataFilter,
  })
}

export const step2AddObjectInsuredProperty = (data: any) => {
  return request({
    url: '/api/v1/SellingProperty/step2-add-object-insured-property',
    method: 'post',
    data: data,
  })
}

export const step2GetObjectInsuredLocationByID = (data: any) => {
  return request({
    url:
      '/api/v1/SellingProperty/step2-object-insured-property-detail-byid?sellingContractId=' +
      data.sellingContractId +
      '&id=' +
      data.id,
    method: 'get',
  })
}

export const calculatorFeePropertyStep3 = (data: any) => {
  data.languageCode = lang_r.toUpperCase()
  return request({
    url: '/api/v1/Pricing/caculator-fee-property-step3',
    method: 'post',
    data: data,
  })
}

export const step2UploadListCargo = (data: any) => {
  const formData = new FormData()
  formData.append('file', data.file)
  return requestFile({
    url:
      '/api/v1/SellingCargo/object-shipment-from-excel?SellingContractId=' + data.sellingContractId,
    method: 'post',
    data: formData,
  })
}

export const createShipmentCargo = (data: any) => {
  data.languageCode = lang_r.toUpperCase()
  return request({
    url: '/api/v1/SellingCargo/create-shipment-cargo',
    method: 'post',
    data: data,
  })
}

export const step3GetObjectInsuredCargoList = (data: any) => {
  let obj = {
    Filters: data.Filters,
    languageCode: lang_r.toUpperCase(),
    Page: data.pageIndex,
    PageSize: data.pageSize,
  }

  return request({
    url: 'api/v1/SellingCargo/step3-object-insured-cargo-list',
    method: 'get',
    headers: {
      'x-query': JSON.stringify(obj),
    },
  })
}
export const searchAndPagingListShipmentCargo = (data: any) => {
  let obj = {
    Filters: data.Filters,
    languageCode: lang_r.toUpperCase(),
    Page: data.pageIndex,
    PageSize: data.pageSize,
  }

  return request({
    url: '/api/v1/SellingCargo/list-shipment-cargo-contract',
    method: 'get',
    headers: {
      'x-query': JSON.stringify(obj),
    },
  })
}
export const step2DeleteObjectInsured = (data: any) => {
  return request({
    url: '/api/v1/SellingCargo/delete-shipment-cargo-by-id',
    method: 'delete',
    data: data,
  })
}
export const step3GetListRiskBenefitDetail = (data: any) => {
  return request({
    url: '/api/v1/SellingProperty/step3-get-list-risk-benefit-detail',
    method: 'post',
    data: data,
  })
}

export const step3AddPropertyRiskBenefit = (data: any) => {
  return request({
    url: '/api/v1/SellingProperty/step3-add-property-risk-benefit',
    method: 'post',
    data: data,
  })
}

export const step2UploadPropertyRisk = (data: any) => {
  const formData = new FormData()
  formData.append('file', data.file)
  formData.append('SellingContractId', data.sellingContractId)
  formData.append('SellingObjectId', data.sellingObjectId)
  return requestFile({
    url: 'api/v1/SellingProperty/step2-upload-excel-risk',
    method: 'post',
    data: formData,
  })
}

export const getListPackageDeductible = (data: any) => {
  return request({
    url:
      '/api/v1/Selling/PackageDeductible/get-list-package-deductible/' +
      data.productCode +
      '/' +
      data.packageCode,
    method: 'get',
  })
}
export const getListContractByAddress = (data: any) => {
  let obj = {
    Page: data.pageNumber,
    PageSize: data.pageSize,
    Filters: data.filter,
  }

  return request({
    url: '/api/v1/SellingProperty/get-list-contract-by-address',
    method: 'get',
    headers: {
      'x-query': JSON.stringify(obj),
    },
  })
}
